export default __webpack_public_path__ + "static/media/MensHealth.620505ce.svg";